(function () {
  function closeAccordionItem(trigger) {
    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;

    trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mobile-menu-accordion-trigger]');
    if (!trigger) return;

    event.preventDefault();

    var panelId = trigger.getAttribute('aria-controls');
    var panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    var accordion = trigger.closest('[data-mobile-menu-accordion]');
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';

    if (accordion) {
      accordion.querySelectorAll('[data-mobile-menu-accordion-trigger][aria-expanded="true"]').forEach(function (openTrigger) {
        if (openTrigger !== trigger) closeAccordionItem(openTrigger);
      });
    }

    trigger.setAttribute('aria-expanded', String(!isOpen));
    panel.hidden = isOpen;
  });
})();
